import { h, Component } from 'preact';
import { Text } from 'preact-i18n';
import { getEntityDescriptor } from '../../lib/supportTicketEntities';
import RelatedRecordPicker from './relatedRecordPicker';

class RelatedRecordsPanel extends Component {
    constructor(props) {
        super(props);
        this.state = { dismissedFor: null };
    }

    render() {
        const {
            entities, draftRelated, onAdd, onRemove,
        } = this.props;
        const { dismissedFor } = this.state;
        if (!entities || entities.length === 0) return null;

        const items = entities
            .map(e => ({ entity: e, descriptor: getEntityDescriptor(e.type) }))
            .filter(d => d.descriptor);
        if (items.length === 0) return null;

        const signature = items.map(({ descriptor }) => descriptor.type).join(',');
        if (dismissedFor === signature) return null;

        return (
            <div class='card border-info mb-3'>
                <div class='card-header bg-info bg-opacity-10 d-flex justify-content-between align-items-center'>
                    <span>
                        <i class='fa-duotone fa-wand-magic-sparkles me-2' />
                        <Text id='support.related.title'>Attach related records so we don't have to guess</Text>
                    </span>
                    <button
                        type='button'
                        class='btn-close'
                        aria-label='Close'
                        onClick={() => this.setState({ dismissedFor: signature })}
                    />
                </div>
                <div class='card-body'>
                    <p class='text-body-secondary small'>
                        <Text id='support.related.help'>Your message seems to reference these. Search and attach the exact record.</Text>
                    </p>
                    {items.map(({ entity, descriptor }) => {
                        const picked = (draftRelated && draftRelated[descriptor.type]) || [];
                        return (
                            <div key={descriptor.type} class='mb-2'>
                                <RelatedRecordPicker
                                    descriptor={descriptor}
                                    initialSearch={entity.suggestedSearch || ''}
                                    onSelect={onAdd}
                                />
                                {picked.length > 0 && (
                                    <div class='d-flex flex-wrap gap-2 mt-1'>
                                        {picked.map(record => (
                                            <span key={record.id} class='badge bg-secondary d-flex align-items-center'>
                                                {descriptor.formatSummary(record)}
                                                <button
                                                    type='button'
                                                    class='btn-close btn-close-white ms-2'
                                                    style='font-size: 0.6rem;'
                                                    aria-label='Remove'
                                                    onClick={() => onRemove(descriptor.type, record.id)}
                                                />
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default RelatedRecordsPanel;
